import type { ReactNode } from "react";
import { useId } from "react";
import cx from "ui/cx";
import IconLocked from "ui/icons/IconLocked";
import styles from "./Radio.module.scss";

export interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  iconLock?: boolean;
  controlled?: boolean; // check/uncheck handled by parent
}

export default function Radio({ label, className, ...props }: RadioProps) {
  // Setting onChange to undefined silences error about not having a handler
  const { disabled, iconLock, controlled, onChange = undefined, ...inputProps } = props;

  const id = useId();

  return (
    <div className={cx(styles.wrapper, "Radio", { styles, disabled, iconLock }, className)} title={inputProps.title}>
      <input
        className={styles.input}
        type="radio"
        {...inputProps}
        id={id}
        onChange={!controlled ? onChange : () => null}
        disabled={disabled || iconLock || controlled}
      />
      <label className={cx(styles.icon, "icon")} htmlFor={id}>
        {iconLock && <IconLocked variant="portal" color="stone" size={10} />}
      </label>
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
}
